import { render, staticRenderFns } from "./plugin.md?vue&type=template&id=a1c80ca6&"
import script from "./plugin.md?vue&type=script&lang=js&"
export * from "./plugin.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports